export {default as cn} from './cn'
export {default as de} from './de'
export {default as el} from './el'
export {default as en} from './en'
export {default as es} from './es'
export {default as fr} from './fr'
export {default as hu} from './hu'
export {default as it} from './it'
export {default as nl} from './nl'
export {default as pl} from './pl'
export {default as pt} from './pt'
export {default as ro} from './ro'
export {default as ru} from './ru'
export {default as tr} from './tr'
export {default as uk} from './uk'

